import { AssignNonModelledElementsRequest } from "@api/apiClient";
import { useAssignNonModelledElements as useAssignNonModelledElementsMutation } from "@api/models";
import useSelectionManager from "@hooks/useSelectionManager";
import { useCallback } from "react";

interface UseAssignNonModelledElementParams {
  /** Callback invoked after successful non-modelled element assignment (e.g., to refetch data) */
  onSuccess?: () => void | Promise<void>;
}

interface UseAssignNonModelledElementResult {
  handleAssignNonModelledElements: () => Promise<void>;
  isAssignNonModelledElementsPending: boolean;
}

export const useAssignNonModelledElement = ({
  onSuccess,
}: UseAssignNonModelledElementParams = {}): UseAssignNonModelledElementResult => {
  const selectionManager = useSelectionManager();
  const projectId = selectionManager.selectedProject?.projectId;
  const mutateAssignNonModelledElements = useAssignNonModelledElementsMutation();

  const handleAssignNonModelledElements = useCallback(async () => {
    const assignNonModelledElementsRequest = new AssignNonModelledElementsRequest({
      projectId,
      modelIds: selectionManager.getSelectedModelIds(),
      scenarioId: selectionManager.selectedScenarioId,
    });
    await mutateAssignNonModelledElements.mutateAsync(assignNonModelledElementsRequest as any);
    await onSuccess?.();
  }, [mutateAssignNonModelledElements, onSuccess, projectId, selectionManager]);

  return {
    handleAssignNonModelledElements,
    isAssignNonModelledElementsPending: mutateAssignNonModelledElements.isPending,
  };
};
